export const LOGOUT_ACTION = 'LOGOUT_ACTION';
